export enum SideSwitcherMode {
  BASIC = 'basic',
  PRO = 'pro',
}
